import React from 'react';

import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Btvoltar from '../../components/buttons/Btvoltar';
import ProblemaItem from './ProblemaItem';
import Login from '../login/Login';
import Modal from '../../components/modal.v2/Modal';

import { WS_PAGAMENTO } from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';

import PaymentInit from './PaymentInit';

import Recaptcha from 'react-recaptcha';
import { GOOGLE_RECAPTCHA_V2 } from '../../config/Config';

const PROBLEMAS = {
  cardiaco: 'Problemas cardíacos',
  renais: 'Problemas renais',
  diabetes: 'Diabetes',
  ombros: 'Dor nos ombros',
  coluna: 'Dor na coluna',
  joelhos: 'Dor nos joelhos',
  naoPossuo: 'Não possuo limitação'
};

const PROBLEMAS_OUTROS = 'problemasOutros';
const PROBLEMAS_ADICIONADOS = 'problemasAdicionados';

const URL_SIGNUP = WS_PAGAMENTO.signup;

class FormProblemas extends React.Component{
  constructor(props){
    super(props);

    const cardiaco = this.getProblemasProps(PROBLEMAS.cardiaco);
    const renais = this.getProblemasProps(PROBLEMAS.renais);
    const diabetes = this.getProblemasProps(PROBLEMAS.diabetes);
    const joelhos = this.getProblemasProps(PROBLEMAS.joelhos);
    const coluna = this.getProblemasProps(PROBLEMAS.coluna);
    const ombros = this.getProblemasProps(PROBLEMAS.ombros);
    const naoPossuo = this.getProblemasProps(PROBLEMAS.naoPossuo);

    this.state = {
      ...props.dados,
      cardiaco,
      renais,
      diabetes,
      joelhos,
      coluna,
      ombros,
      naoPossuo,
      strings: STRINGS[window.LANGUAGE],
      gCaptcha: null
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.addProblemaOutro = this.addProblemaOutro.bind(this);
    this.onRemoveProblema = this.onRemoveProblema.bind(this);
    this.backStep = this.backStep.bind(this);
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  componentDidMount(){
    if (this.captchaDemo) {
      this.captchaDemo.reset();
    }
  }

  onLoadRecaptcha() {
    if (this.captchaDemo) {
        this.captchaDemo.reset();
    }
  }

  verifyCallback(recaptchaToken) {
    this.setState({
      gCaptcha: recaptchaToken
    });
  }

  backStep(e){
    e.preventDefault();
    this.changeStep(this.props.step-1);
  }

  getProblemasProps(valueCheck){
    let doenca = '';
    this.props.dados.problemasAdicionados.map((value,i)=>{
      if(value === valueCheck){
        doenca = true;
      }
    });
    return doenca;
  }

  handleSubmit(){
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      usuarioSenha,
      erroLogar,
      preenchaGoogleCaptcha
    }
    = this.state.strings;

    const self = this;

    const props = this.props.dados;

    const dadosSignup = {
    	nome: props.nome,
    	foto: "",
    	data_nascimento: props.data_nascimento,
    	email: props.email,
    	telefone: props.telefone,
    	senha: props.senha,
    	cpf_cnpj: props.cpf_cnpj,
    	uf: props.uf,
      sexo: props.sexo,
    	cep: props.cep,
    	logradouro: props.logradouro,
    	bairro: props.bairro,
    	cidade: props.cidade,
    	numero: props.numero,
    	complemento: props.complemento,
      onde_treina: props.onde_treina,
      qtd_dias: props.qtd_dias,
      tipo_treino: props.tipo_treino ? props.tipo_treino : 'E',
      tempo_musculacao: props.tempo_musculacao,
      problemas: props.problemas,
      peso: props.peso,
      altura: props.altura
    }

    const gCaptcha = this.state.gCaptcha;

    if(!gCaptcha){
      const msg = {
        title: atencao,
        text: preenchaGoogleCaptcha
      };
      Dialog.create(msg);
      return;
    }

    dadosSignup.gCaptcha = gCaptcha;
    dadosSignup.typePagamentoWeb = true;

    Requisitions({
      url: URL_SIGNUP,
      data: dadosSignup,
      sucess:function(data){
        if(data.status){
          Login.setDataUser({usuario: dadosSignup.email, senha: dadosSignup.senha, user:data.user});
          self.props.history.push('/area-restrita/bem-vindo/');
          Modal.destroy();
        }else{
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }

        self.onLoadRecaptcha();
        self.setState({gCaptcha:null});
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroLogar
        });
      }
    });
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const nomeProblema = PROBLEMAS[name];

    //-----
    //checa o array dos problemas
    let problema;
    const array = [...this.state[PROBLEMAS_ADICIONADOS]];

    for(let i=0; i<array.length; i++){
      const item = array[i];
      //caso o nome do problema for o do array problemasAdicionados salvamos o index do item
      if(nomeProblema === item){
        //convertemos em string pois se o index for 0 é como se ele não existisse
        problema = String(i);
      }
    }

    if(problema){
      //se o problema já existir no array o removemos
      array.splice(problema, 1);
    }else{
      array.push(nomeProblema);
    }
    //-----

    this.setState({
      [name]: value,
      problemasAdicionados: array
    });

    //const { changeForm } = this.props;
    //changeForm(array, PROBLEMAS_ADICIONADOS);

    this.props.changeData({name: PROBLEMAS_ADICIONADOS, value: array});

    this.addProblema(array, PROBLEMAS_ADICIONADOS);
  }

  //remove o problema de acordo com seu index
  onRemoveProblema(index) {
    const array = this.state[PROBLEMAS_OUTROS];
    array.splice(index, 1);

    this.setState({
      problemas: array
    });

    this.setProblemas(array);
  }

  //adiciona um outro problema
  addProblemaOutro(e){
    const problema = document.getElementById('input-problema');
    const value = problema.value;
    const arr = [...this.state.problemasOutros, value];
    problema.value = '';

    this.setProblemas(arr);

    e.preventDefault();
  }

  setProblemas(arr) {
    this.setState({
      problemasOutros: arr
    });

    //const { changeForm } = this.props;
    //changeForm(arr, PROBLEMAS_OUTROS);

    this.props.changeData({name: PROBLEMAS_OUTROS, value: arr});

    this.addProblema(arr, PROBLEMAS_OUTROS);
  }

  addProblema(arr, type) {
    const { problemas } = this.props;
    const prob =
      PROBLEMAS_OUTROS === type ?
        this.props.dados[PROBLEMAS_ADICIONADOS] :
        this.props.dados[PROBLEMAS_OUTROS];

    let problemasTemp = [...prob, ...arr];

    //changeForm(problemasTemp, 'problemas');
    this.props.changeData({name: 'problemas', value: problemasTemp});
  }

  changeStep(step) {
    this.props.changeStep({ step:step });
  }

  getProblemas(){
    const arr = this.state.problemasOutros.map((value,i)=>{
      return <ProblemaItem
        onRemove={()=>{this.onRemoveProblema(i)}}
        key={i}
        value={value}
        index={i}
      />;
    });

    return arr;
  }

  render(){
    const strings = this.state.strings;
    const problemas = this.getProblemas();

    return(
      <div  className='box-formulario'>
        <div className='box-title'>
          {/*<span className='cadastro-title'><strong>Cadastro - </strong>1 de 3</span>*/}
          <span className='title-box-title'>{strings.problemasSaude}</span>
        </div>
        <div>
          <div>
            <div className="pure-u-1-2 problema-item">
              <input
                name="naoPossuo"
                type="checkbox"
                checked={this.state.naoPossuo}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.nenhumProblema}</span>
            </div>
            <div className="pure-u-1-2 problema-item">
              <input
                name="cardiaco"
                type="checkbox"
                checked={this.state.cardiaco}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.cardiaco}</span>
            </div>
            <div className="pure-u-1-2 problema-item">
              <input
                name="renais"
                type="checkbox"
                checked={this.state.renais}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.renais}</span>
            </div>
            <div className="pure-u-1-2 problema-item">
              <input
                name="diabetes"
                type="checkbox"
                checked={this.state.diabetes}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.diabetes}</span>
            </div>
            <div className="pure-u-1-2 problema-item">
              <input
                name="joelhos"
                type="checkbox"
                checked={this.state.joelhos}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.joelhos}</span>
            </div>
            <div className="pure-u-1-2 problema-item">
              <input
                name="coluna"
                type="checkbox"
                checked={this.state.coluna}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.coluna}</span>
            </div>
            <div className="pure-u-1-2 problema-item">
              <input
                name="ombros"
                type="checkbox"
                checked={this.state.ombros}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.ombros}</span>
            </div>
            <div className='txtProblemas'>{strings.outrosProblemas}</div>
            <div className='box-insert-problema'>
              <div className='input-problema pure-u-18-24'>
                <span>
                  <input id='input-problema' name='problema' placeholder={strings.digiteProblema} />
                </span>

              </div>
              <div className='pure-u-4-24'>
                <a href='#' className='bt-adicionar-problema ' onClick={this.addProblemaOutro}>Adicionar</a>
              </div>
              <div className='obsProblema'><p>{strings.obsProblema}</p></div>
            </div>
            <div>
              {problemas}
            </div>
          </div>
          <br />
          <div>
              <Recaptcha
                ref={e => this.captchaDemo = e}
                sitekey={GOOGLE_RECAPTCHA_V2}
                size="normal"
                hl="pt-BR"
                verifyCallback={this.verifyCallback}
              />
              <br />
            </div>
          <div className="box-center-button">
            <Button text={strings.txtContinuar} onClick={this.handleSubmit} type='button' classes="button-login simple-button" />
              <Btvoltar text='Voltar' onClick={this.backStep} />
        </div>
        </div>
      </div>
    )
  }
}

export default FormProblemas;



// WEBPACK FOOTER //
// ./src/classes/cadastro/FormProblemas.js